import * as React from "react";
import { FaArrowsAlt } from "react-icons/fa";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { Switch } from "../switch/Switch";
import { ScrollList, ScrollListItem } from "../../layout/scroll-list/index";

interface Item {
  _id: string;
  label: string;
  enabled: boolean;
}
interface Props {
  height: number | null;
  items: Item[];
  onCheck: (index: number, item: Item) => void;
  onSortEnd: (data: { oldIndex: number; newIndex: number }) => void;
}

const DragHandle = SortableHandle(() => (
  <div className="cursor-move p-lr-2 p-tb-1">
    <FaArrowsAlt/>
  </div>
));

const SortableItem = SortableElement((props: { item: Item, parent: Props, itemIndex: number; }) => (
  <ScrollListItem
    className="flex-l-r-center no-select"
    onClick={() => props.parent.onCheck(props.itemIndex, props.item)}>
    <div className="flex-line centered">
      <Switch
        id={`${props.item._id}-switch-list`}
        checked={props.item.enabled}
        onChange={() => props.parent.onCheck(props.itemIndex, props.item)}/>
      <p className="m-l-3">{props.item.label}</p>
    </div>
    <DragHandle/>
  </ScrollListItem>
));

const SortableItemContainer = SortableContainer((props: Props) => {
  return (
    <ScrollList height={props.height}>
      {props.items.map((item, i) => (
        <SortableItem key={`item-${i}`} index={i} item={item} itemIndex={i} parent={props}/>
      ))}
    </ScrollList>
  );
});

export class SwitchListSortable extends React.Component<Props> {
  render() {
    const { height, items, onCheck, onSortEnd } = this.props;
    return (
      <SortableItemContainer
        helperClass="zindex-100 bsl-2"
        pressDelay={50}
        useDragHandle={true}
        height={height}
        items={items}
        onCheck={onCheck}
        onSortEnd={onSortEnd}/>
    );
  }
}
